import { useLocation, useNavigate } from "react-router-dom";
import { frontendRoutes } from "../utility/frontendRoutes";

// Sends a logged-out user to /login, remembering the current page so they
// come back to it afterwards (GuestRoute and Login read state.from).
// Prefer this over `window.location.href = "/login"`, which drops that state.
const useGoToLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return () => navigate(frontendRoutes.LOGIN, { state: { from: location } });
};

export default useGoToLogin;
